/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_CopyrightInputs */

const de_commons_footer_copyright = /** @type {(inputs: Commons_Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© Exaring AG`)
};

/** @type {(inputs: Commons_Footer_CopyrightInputs) => LocalizedString} */
const en_commons_footer_copyright = de_commons_footer_copyright;

/**

* @param {Commons_Footer_CopyrightInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_copyright = /** @type {((inputs?: Commons_Footer_CopyrightInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_CopyrightInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_copyright(inputs)
	return en_commons_footer_copyright(inputs)
});